import { defineTranslationScope } from "@app/shared/i18n/translation-scope";

export const scope = defineTranslationScope("shared/generic-managers/generic-field-editor/custom-field-types/cerrix-editor-popup");
